import { QRCodeSVG } from "qrcode.react";

import { Button } from "../../components/Button";
import { QR_PREFIX, RECEIPT_BONUS_PERCENT } from "./constants";

export function BonusAdminCreditPage({
  receiptRub,
  onReceiptRubChange,
  previewBonus,
  generating,
  error,
  generatedToken,
  generatedBonusAmount,
  onGenerate,
}) {
  return (
    <div className="bonusGeneratePage">
      <div className="homeSurface bonusGeneratePage__surface">
        <div className="bonusGeneratePage__body">
          <label className="field">
            Сумма чека, ₽
            <input
              type="text"
              inputMode="decimal"
              placeholder="Например, 1200"
              value={receiptRub}
              onChange={(e) => onReceiptRubChange(e.target.value)}
            />
          </label>
          {previewBonus != null ? (
            <div className="bonusGeneratePage__previewCard" aria-live="polite">
              <span className="bonusGeneratePage__previewLabel">Начисление при сканировании</span>
              <span className="bonusGeneratePage__previewValue">
                +{previewBonus}{" "}
                <span className="bonusGeneratePage__previewUnit">бонусов</span>
              </span>
              <span className="bonusGeneratePage__previewHint">
                {RECEIPT_BONUS_PERCENT}% от суммы чека
              </span>
            </div>
          ) : null}
          <Button variant="accent" onClick={onGenerate} disabled={generating}>
            {generating ? "Генерация..." : "Создать QR"}
          </Button>
          {error ? <p className="errorMessage bonusGeneratePage__error">{error}</p> : null}
        </div>
      </div>

      {generatedToken ? (
        <div className="homeSurface bonusGeneratePage__surface bonusGeneratePage__surface--qr">
          <div className="bonusGeneratePage__qrBlock">
            <div className="bonusGeneratePage__qrFrame">
              <QRCodeSVG
                value={`${QR_PREFIX}${generatedToken}`}
                size={216}
                bgColor="#ffffff"
                fgColor="#1d1d1b"
                level="M"
              />
            </div>
            <p className="bonusGeneratePage__qrHint">
              {generatedBonusAmount != null ? (
                <>
                  Гость получит <strong>+{generatedBonusAmount}</strong> бонусов.{" "}
                </>
              ) : null}
              Покажите QR для сканирования в приложении Telegram.
            </p>
          </div>
        </div>
      ) : null}
    </div>
  );
}
